/* Afkar Plus — product spotlight v2: rotating centre product + quick-add buttons + phone swipe-row counter (BeyondADS, 23 Sep 2026) */
(function () {
  'use strict';
  if (window.__aspLoaded) return;
  window.__aspLoaded = true;

  var routes = window.routes || {};
  var ADD = (routes.cart_add_url || '/cart/add') + '.js';

  function paintBubble(sections) {
    var html = sections && sections['cart-icon-bubble'];
    var el = document.getElementById('cart-icon-bubble');
    if (!html || !el) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var inner = doc.querySelector('.shopify-section');
    el.innerHTML = inner ? inner.innerHTML : html;
  }

  function init(root) {
    if (root.__asp) return;
    root.__asp = true;

    /* ---------- rotation ---------- */
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-asp-item]'));
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-asp-row]'));
    var navDots = Array.prototype.slice.call(root.querySelectorAll('[data-asp-go]'));
    var n = items.length;
    var i = 0, timer = null, paused = false;
    var auto = root.getAttribute('data-auto') === 'true';
    var dur = Math.max(2, parseInt(root.getAttribute('data-interval'), 10) || 3) * 1000;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    function render() {
      items.forEach(function (el, k) {
        var on = k === i;
        el.classList.toggle('is-active', on);
        if (on) el.removeAttribute('aria-hidden'); else el.setAttribute('aria-hidden', 'true');
      });
      rows.forEach(function (r) { r.classList.toggle('is-active', parseInt(r.getAttribute('data-asp-row'), 10) === i); });
      navDots.forEach(function (b) { var k = parseInt(b.getAttribute('data-asp-go'), 10); b.classList.toggle('is-active', k === i); b.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
    }
    function go(k) { i = ((k % n) + n) % n; render(); restart(); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() {
      stop();
      if (!auto || reduce || n < 2 || paused) return;
      timer = setInterval(function () { if (document.hidden) return; i = (i + 1) % n; render(); }, dur);
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-asp-go]');
      if (b) { e.preventDefault(); go(parseInt(b.getAttribute('data-asp-go'), 10) || 0); }
    });
    if (canHover) {
      rows.forEach(function (r) {
        r.addEventListener('mouseenter', function () { var k = parseInt(r.getAttribute('data-asp-row'), 10); if (k !== i) { i = k; render(); } });
      });
    }
    root.addEventListener('mouseenter', function () { paused = true; stop(); });
    root.addEventListener('mouseleave', function () { paused = false; restart(); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(i + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(i - 1); }
    });

    /* ---------- quick add (row "+" buttons and the centre button) ---------- */
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-asp-add]');
      if (!btn || btn.classList.contains('is-busy')) return;
      e.preventDefault();
      var id = parseInt(btn.getAttribute('data-variant'), 10);
      var msg = btn.parentNode.querySelector('[data-asp-msg]');
      if (msg) { msg.hidden = true; msg.textContent = ''; }
      btn.classList.add('is-busy');
      fetch(ADD, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: 'cart-icon-bubble' }) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body && (res.body.description || res.body.message) || 'Could not add to the cart');
          paintBubble(res.body && res.body.sections);
          document.dispatchEvent(new CustomEvent('afkar:cart:updated', { detail: { variant: id } }));
          btn.classList.add('is-added');
          setTimeout(function () { btn.classList.remove('is-added'); }, 1600);
        })
        .catch(function (err) {
          if (msg) { msg.textContent = err && err.message ? err.message : 'Could not add to the cart'; msg.hidden = false; setTimeout(function () { msg.hidden = true; }, 4000); }
          else { btn.setAttribute('title', err && err.message ? err.message : 'Could not add to the cart'); }
        })
        .then(function () { btn.classList.remove('is-busy'); });
    });

    /* ---------- phone swipe row: '02 / 06' counter + progress bar follow the scroll ---------- */
    var track = root.querySelector('[data-asp-track]');
    if (track) {
      var cur = root.querySelector('[data-asp-cur]');
      var bar = root.querySelector('[data-asp-bar]');
      var cards = Array.prototype.slice.call(track.querySelectorAll('[data-asp-mcard]'));
      var sync = function () {
        if (!cards.length) return;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        var step = cards[0].offsetWidth + gap;
        if (!step) return;
        var k = Math.max(0, Math.min(cards.length - 1, Math.round(track.scrollLeft / step)));
        var per = Math.max(1, Math.round((track.clientWidth + gap) / step));
        var last = Math.min(cards.length, k + per);
        if (cur) cur.textContent = ('0' + (k + 1)).slice(-2);
        if (bar) bar.style.width = (last / cards.length * 100) + '%';
      };
      track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
      window.addEventListener('resize', sync);
      sync();
      root.__aspSync = sync;
    }

    render();
    restart();
    root.__aspGo = go;
  }

  function boot() { document.querySelectorAll('[data-asp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
